import axios from 'axios'
import {toData} from "./util";

export function getRevisions(entity, id, property): Promise {
  return axios.get(`/api/revisions/${entity}/${id}/${property}`).then(toData)
}

export function getDeletedLocations(id) : Promise {
  return axios.get(`/api/revisions/deleted-locations/${id}`).then(toData)
}
